import React from 'react';
import { IconProps } from '../types';
const MinecraftBlazePowder: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="1" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(255, 255, 181, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(255, 254, 49, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(255, 163, 0, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(255, 163, 0, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="1" y="7" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(231, 133, 0, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(255, 163, 0, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(255, 255, 181, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="1" y="8" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(255, 255, 181, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(255, 255, 110, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(202, 140, 9, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="1" y="9" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(255, 217, 66, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(251, 191, 49, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(255, 255, 110, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(255, 203, 0, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(202, 140, 9, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(255, 224, 0, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(255, 255, 181, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(168, 79, 0, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(255, 163, 0, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(248, 163, 0, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(202, 140, 9, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(255, 224, 0, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(255, 255, 181, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(202, 140, 9, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(255, 255, 181, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(255, 163, 0, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(255, 254, 49, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(255, 163, 0, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(210, 128, 3, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(255, 255, 181, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(255, 203, 0, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(255, 216, 66, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(255, 224, 0, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(205, 86, 0, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(255, 203, 0, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(202, 118, 0, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(255, 163, 0, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(255, 223, 70, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(200, 97, 0, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(171, 62, 0, 255)" />
<rect x="14" y="11" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(251, 140, 0, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(205, 86, 0, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(255, 203, 0, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(205, 101, 0, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(255, 234, 77, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(234, 138, 0, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(168, 79, 0, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(168, 73, 0, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(205, 101, 0, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(171, 62, 0, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(168, 73, 0, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(168, 79, 0, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(171, 62, 0, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(149, 51, 0, 255)" />
</svg>);
export default MinecraftBlazePowder;